export default "__VITE_ASSET__e25a99c4__"